<template>
    <div class="v-alert" :class="[`v-alert--${type}`]">
        <span v-if="icon" class="v-alert-icon"><i :class="icon"></i></span>
        <div class="v-alert-title">
          <slot>
            {{ message }}
          </slot>
        </div>
    </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'VAlert',
    props: {
        type: {
            type: String,
            default: 'wran'
        },
        icon: {
            type: String,
            default: ''
        },
        message: String
    }
})
</script>

<style lang="scss">

@import "~@/assets/scss/base/module/_mixins.scss";

:root {
    --v-alert-info-background-color: #f4f4f6;
    --v-alert-info-text-color: var(--text-color-dark);

    --v-alert-error-background-color: var(--color-danger-light);
    --v-alert-error-text-color: var(--color-danger);

    --v-alert-success-background-color: #ccefed;
    --v-alert-success-text-color: var(--color-success);

    --v-alert-wran-background-color: #{ rgba(#F2B203, .06) };
    --v-alert-wran-text-color: #CC4B0C;



    --v-alert-font-size: var(--font-size-xs);
}

.v-alert {
    display: flex;
    border-radius: var(--border-radius);
    padding: 4px 12px 3px;
    font-size: var(--v-alert-font-size);
    line-height: 1.4;
    // margin: 10px;

    &-icon {
        // width: 24px;
        // height: 24px;
        // border-radius: 50%;
        // color: #fff;
        // text-align: center;
        // line-height: 24px;
    }

    .v-alert-title {
        margin-left: 6px;
    }

    @include m(info) {
        background: var(--v-alert-info-background-color);
        color: var(--v-alert-info-text-color);

        .v-msg-icon {
            color: var(--v-alert-info-text-color);
        }
    }


    @include m(success) {
        background: var(--v-alert-success-background-color);
        color: var(--v-alert-success-text-color);

        .v-msg-icon {
            color: var(--v-alert-success-text-color);
        }
    }

    @include m(error) {
        background: var(--v-alert-error-background-color);
        color: var(--v-alert-error-text-color);

        .v-msg-icon {
            color: var(--v-alert-error-text-color);
        }
    }

    @include m(wran) {
        background: var(--v-alert-wran-background-color);
        color: var(--v-alert-wran-text-color);

        .v-msg-icon {
            color: var(--v-alert-wran-text-color);
        }
    }
}

</style>
